import Vue from 'vue';
import Vuex from 'vuex';
import VueRouter from 'vue-router';

// Import store modules to use in the landing content components
import ContentStoreModule from '../content/store/ContentStoreModule';

// Import landing content components
import PrimaryLandingContent from './components/PrimaryLandingContent.vue';
import SecondaryLandingContent from './components/SecondaryLandingContent.vue';
import NewsContentCard from './components/NewsContentCard.vue';
import LinksContentCard from './components/LinksContentCard.vue';

// Register dependent custom components
Vue.component('news-content-card', NewsContentCard);
Vue.component('links-content-card', LinksContentCard);

// Create custom store comprised of required sub-modules
export function getStore(){
    return new Vuex.Store({modules: {content: ContentStoreModule}});
}

export function getRouter() {
    // Create a custom router for the claims entry app
    return new VueRouter({
        routes: [{
            path: '/',
            redirect: '/home',
            component: PrimaryLandingContent
        }, {
            path: '/home',
            name: 'home',
            component: PrimaryLandingContent
        }, {
            path: '/links/:linkCardTitle/:linkCardBundle/:linkTitle/:linkContentItem',
            name: 'link',
            component: SecondaryLandingContent,
            props: (route) => ({
                linkCardTitle: route.params.linkCardTitle,
                linkCardBundle: route.params.linkCardBundle,
                linkTitle: route.params.linkTitle,
                linkContentItem: route.params.linkContentItem
            })
        }]
    });
}
